import type { CSSObject } from '@emotion/react'
import { Color, OppositeTheme, Spacing } from '@opallabs/gem'
import { WithRequiredTheme } from '@opallabs/lapidary'

type StyleProps = WithRequiredTheme

export const container: CSSObject = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: [`${Spacing.L}px`, `${Spacing.M}px`].join(' '),
}

export const iconWrapper = ({ theme }: StyleProps): CSSObject => ({
  color: Color[OppositeTheme[theme]].Translucent.A48,
})

export const icon = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Default,
})
